import { Component, inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ApiService } from "../../../../../../../shared/src";
import { SearchComponent } from "../../../../components/search/search.component";
import { MHeaderComponent } from "../m-header/m-header.component";
import { BalanceDisplayComponent } from "../balance-display/balance-display.component";
import { NavService } from "../../../../../../../shared/src/lib/services/nav.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CoreService } from "../../../../../../../shared/src/lib/services/core.service";
import { DomainService } from "../../../../../../../shared/src/lib/services/domain.service";
import { AsyncPipe } from "@angular/common";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { environment } from "../../../../../../../shared/src/environments/environment";
import { SentryFeedbackComponent } from "../../../../components/sentry-feedback/sentry-feedback.component";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
  imports: [RouterLink, SearchComponent, MHeaderComponent, BalanceDisplayComponent, TranslateModule, AsyncPipe, SentryFeedbackComponent],
})
export class HeaderComponent {
  apiService = inject(ApiService);
  navService = inject(NavService);
  translate = inject(TranslateService);
  coreService = inject(CoreService);
  domainService = inject(DomainService);
  showMobileBalance = false;
  user: any = null;

  protected readonly environment = environment;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe(["(max-width: 900px)"]).subscribe((state: BreakpointState) => {
      this.showMobileBalance = state.matches;
    });
    const app = this.apiService.getUserToken();
    this.user = app.user;
    console.log(this.apiService.getUserToken());
  }

  get showFeedbackButton() {
    return this.environment.SENTRY_ENABLED;
  }
}
